import * as paraphraserLogics from '@chegg-wt/core-wa/state/logics'
import * as appLogics from './app/logics'
import * as bibliographyLogics from './bibliography/logics'
import * as citationLogics from './citation/logics'
import * as createCitationLogics from './createCitation/logics'
import * as currentProjectLogics from './currentProject/logics'
import * as foldersLogics from './folders/logics'
import * as formLogics from './form/logics'
import * as projectsLogics from './projects/logics'
import * as rioLogics from './instrumentation/rio/logics'
import * as stylesLogics from './styles/logics'
import * as userLogics from './user/logics'
import * as modalLogics from './modals/logics'

const rootLogic = [
  ...Object.values(appLogics),
  ...Object.values(bibliographyLogics),
  ...Object.values(citationLogics),
  ...Object.values(createCitationLogics),
  ...Object.values(currentProjectLogics),
  ...Object.values(foldersLogics),
  ...Object.values(formLogics),
  ...Object.values(projectsLogics),
  ...Object.values(rioLogics),
  ...Object.values(stylesLogics),
  ...Object.values(userLogics),
  ...Object.values(modalLogics),
  ...Object.values(paraphraserLogics),
]

export default rootLogic
